<!-- boostrap version changes -->
<div class="tab-content nav-tab-content">
  <div role="tabpanel" class="tab-pane active" id="step-1">
    <form [formGroup]="addClient" (ngSubmit)="submitFrom()">
      <!-- added row class -->
      <!-- div class="row middle-box lg-midd"> -->
      <div class="row p-0">
        <div class="col-md-6 pt-10 blue-seprator">
          <!-- added row class -->
          <div class="col-md-12 col-lg-12 row">
            <!-- added row and p-0 class -->
            <div class="col-md-12 right-most p-0">Total Rows:- <b>{{rowData == null ? '0' : rowData.length}}</b>

              <div class="" style="float: right;margin-right: -12px;">
                <label class="radio-inline">
                  <input type="radio" name="Is_Active_Inactive" id="active" [value]="'true'"
                    (click)="showActiveInactive('Active')" checked>
                  Active
                </label>
                <label class="radio-inline">
                  <input type="radio" id="inactive" name="Is_Active_Inactive" [value]="'true'"
                    (click)="showActiveInactive('De-Active')">
                  Inactive
                </label>
              </div>
            </div>
          </div>
          <div class="client-sticky-tbl sticky-table sticky-ltr-cells border-0 table-hight">

            <ag-grid-angular [enableSorting]="true" [enableFilter]="true" [pagination]="true" [paginationPageSize]="15"
              class="ag-theme-balham grid-w" [rowData]="rowData" [columnDefs]="columnDefs"
              (rowClicked)='onCellClicked($event)' [suppressDragLeaveHidesColumns]="true"
              [suppressDragLeaveHidesColumns]="true" [rowSelection]="rowSelection" (gridReady)="onGridReady($event)"
              [suppressColumnVirtualisation]="true">
            </ag-grid-angular>
          </div>
        </div>
        <!-- removed p-0 class -->
        <div class="col-md-6">
          <!-- added row and removed p-0 -->
          <div class="col-md-12 row">
            <!-- added p-0 -->
            <div class="col-md-12 col-sm-12 p-0">
              <div class="heading-panel sT-hight pl-0">
                <span class="text-sm text-ellipsis heading-txt t-uppercase blue-text">Create Client</span>
              </div>
            </div>
            <!-- added row and removed p-0 -->
            <div class="col-md-12 p-0 row">
              <div class="form-group col-md-6">
                <input type="hidden" class="form-control" placeholder="Id" formControlName="Id"
                  [(ngModel)]="clientData.Id">
                <label for="Client_Name" class="label-std control-label p-0 b-600">Client Name</label>
                <input type="text" class="form-control" placeholder="" formControlName="Client_Name"
                  [(ngModel)]="clientData.Client_Name" (focusout)="setDBName($event)">
                <label class=" error" *ngIf="addClient.get('Client_Name').hasError('required') && validated">Client
                  Name is Required</label>
                <label class=" error" *ngIf="addClient.get('Client_Name').hasError('maxlength') && validated">Client
                  Maximum 50 character allowed</label>
                <label class=" error" *ngIf="addClient.get('Client_Name').hasError('pattern') && validated">
                  Special character not allowed</label>
                <label class=" error" *ngIf="spaceValidation && validated">Space not allowed in Client Name</label>
              </div>
              <div class="form-group col-md-6">
                <label for="DB_Server_Name" class="label-std control-label p-0 b-600">DB Server Name</label>
                <input type="text" class="form-control" id="DB_Server_Name" placeholder=""
                  formControlName="DB_Server_Name" [(ngModel)]="clientData.DB_Server_Name">
                <label class=" error"
                  *ngIf="addClient.get('DB_Server_Name').hasError('required') && validated">DB_Server_Name
                  is Required</label>
                <label class=" error" *ngIf="addClient.get('DB_Server_Name').hasError('maxlength') && validated">Maximum
                  100 character allowed</label>
              </div>
              <div class="form-group col-md-6">
                <label for="DB_Name" class="label-std control-label p-0 b-600">DB Name</label>
                <input type="text" class="form-control" formControlName="DB_Name" [(ngModel)]="DB_Name">
                <label class=" error" *ngIf="addClient.get('DB_Name').hasError('required') && validated">DB_Name
                  is Required</label>
                <label class=" error" *ngIf="addClient.get('DB_Name').hasError('maxlength') && validated">Maximum
                  100 character allowed</label>
              </div>
              <div class="form-group col-md-6">
                <label for="DB_Username" class="label-std control-label p-0 b-600">DB User Name</label>
                <input type="text" class="form-control" placeholder="" formControlName="DB_Username"
                  [(ngModel)]="clientData.DB_Username">
                <label class=" error" *ngIf="addClient.get('DB_Username').hasError('required') && validated">DB_Username
                  is Required</label>
                <label class=" error" *ngIf="addClient.get('DB_Username').hasError('maxlength') && validated">Maximum
                  50 character allowed</label>
              </div>
              <div class="form-group col-md-6">
                <label for="DB_Password" class="label-std control-label p-0 b-600">DB Password</label>
                <input type="password" class="form-control" formControlName="DB_Password"
                  [(ngModel)]="clientData.DB_Password">
                <label class=" error" *ngIf="addClient.get('DB_Password').hasError('required') && validated">DB_Password
                  is Required</label>
                <label class=" error" *ngIf="addClient.get('DB_Password').hasError('maxlength') && validated">Maximum
                  30 character allowed</label>
              </div>

              <!-- Original_Client_Name -->
              <div class="form-group col-md-6">
                <label for="DB_Password" class="label-std control-label p-0 b-600">Original Client Name</label>
                <input type="text" class="form-control" formControlName="Original_Client_Name"
                  [(ngModel)]="clientData.Original_Client_Name">
                <label class=" error"
                  *ngIf="addClient.get('Original_Client_Name').hasError('required') && validated">Original Client Name
                  is Required</label>
                <!-- <label class=" error" *ngIf="addClient.get('Original_Client_Name').hasError('maxlength') && validated">Maximum
         30 character allowed</label> -->
              </div>
              <!-- SubClient_Name -->
              <div class="form-group col-md-6">
                <label for="DB_Password" class="label-std control-label p-0 b-600">SubClient Name</label>
                <input type="text" class="form-control" formControlName="SubClient_Name"
                  [(ngModel)]="clientData.SubClient_Name">
                <!--
                  <label class="error" *ngIf="addClient.get('DB_Password').hasError('required') && validated">DB_Password is Required</label>
        <label class=" error" *ngIf="addClient.get('DB_Password').hasError('maxlength') && validated">Maximum 30 character allowed</label> -->
              </div>

              <!-- Added input for authenticate days -->
              <div class="form-group col-md-6">
                <label for="authenticate_days" class="label-std control-label p-0 b-600">Authenticate Days</label>
                <input type="text" class="form-control" formControlName="AuthenticateDays"
                  [(ngModel)]="clientData.AuthenticateDays" placeholder="Enter value between 3 to 14" maxlength="2">
                <label class=" error"
                  *ngIf="addClient.get('AuthenticateDays').hasError('required') && validated">Authenticate Days
                  Required</label>
                <label class=" error"
                  *ngIf="(addClient.get('AuthenticateDays').hasError('min') || addClient.get('AuthenticateDays').hasError('max')) && validated">
                  Enter value between 3 to 14</label>
                <label class=" error" *ngIf="addClient.get('AuthenticateDays').hasError('pattern') && validated">
                  Special character not allowed</label>
              </div>
            </div>
            <!-- added p-0 class -->
            <div class="col-md-12 p-0">
              <hr class="mt-10 mb-10">
              <div class="form-group" style="margin: 2px;">
                <div class="col-md-12 p-0">
                  <span class="p-0 text-left mr-10">
                    <input type="hidden" formControlName="Updated_Date" [(ngModel)]="clientData.Updated_Date">
                    <label class="custom-control client-conf">
                      <input type="checkbox" id="ac-active" [checked]="clientData.Is_Active" formControlName="Is_Active"
                        [(ngModel)]="Is_Active" class="mr-5 mt-0" (click)="check()">
                      <label for="ac-active" class="label-status">Active</label>
                    </label>
                  </span>

                  <span class="mr-10 p-0 text-left">
                    <label class="custom-control client-conf">
                      <input type="checkbox" id="ag-report" [checked]="clientData.Is_Aging_Report"
                        formControlName="Is_Aging_Report" [(ngModel)]="Is_Aging_Report" class="mr-5 mt-0">
                      <label for="ag-report" class="label-status">Aging Report</label>
                    </label>
                  </span>

                  <span class="p-0 text-left mr-10">
                    <label class="custom-control client-conf">
                      <input type="checkbox" id="is-pcn" [checked]="clientData.Is_PCN" formControlName="Is_PCN"
                        [(ngModel)]="Is_PCN" class="mr-5 mt-0" (change)="checkPCN()">
                      <label for="is-pcn" class="label-status">PCN</label>
                    </label>
                  </span>

                  <!-- <span class="mr-10 text-left" *ngIf="show_Is_Appeal_Processed">
                    <label class="custom-control client-conf">
                      <input type="checkbox" id="ac-active1" [checked]="clientData.Is_Appeal_Processed"
                        formControlName="Is_Appeal_Processed" [(ngModel)]="clientData.Is_Appeal_Processed"
                        class="mr-5 mt-0">
                      <label for="ac-active1" class="label-status">Activate Appeal Process</label>
                    </label>
                  </span> -->

                  <span class="mr-10 text-left">
                    <label class="custom-control client-conf">
                      <input type="checkbox" id="ac-standardAction" [checked]="clientData.Standard_Action_Code"
                        formControlName="Standard_Action_Code" [(ngModel)]="clientData.Standard_Action_Code"
                        class="mr-5 mt-0">
                      <label for="ac-standardAction" class="label-status">Standard Action</label>
                    </label>
                  </span>


                </div>
              </div>
              <div class="form-group" class="enableSetcls">
                <div class="row">
                  <span class="mr-10 text-left">
                    <label class="custom-control client-conf">
                      <input type="checkbox" id="ac-multipleGrid" [checked]="clientData.Is_MultipleGrid"
                        formControlName="Is_MultipleGrid" [(ngModel)]="clientData.Is_MultipleGrid" class="mr-5 mt-0">
                      <label for="ac-multipleGrid" class="label-status">Multiselect</label>
                    </label>
                  </span>
                  <ng-container *ngIf="clientData.Is_MultipleGrid">
                    <div class="d-flex">
                      <label class=" label-std control-label p-0 b-600 pl-0">Enable Set</label>
                      <select class="form-control EnableSetDrop" formControlName="EnableSetID"
                        [(ngModel)]="clientData.EnableSetID">
                        <option *ngFor="let sub of EnableSet" [ngValue]="sub.EnableSetID"> {{sub.value}} </option>
                      </select>
                    </div>
                  </ng-container>
                </div>
              </div>
              <!-- <div class="form-group">
                <label class=" label-std control-label p-0 b-600 pl-0" for="">Concluder</label>
                <div class="radioBorder">
                  <label class="radio-inline">
                    <input type="radio" name="Is_Super_Concluder_Process" id="semi-concluder" [value]="'false'"
                      formControlName="Is_Super_Concluder_Process" [(ngModel)]="clientData.Is_Super_Concluder_Process">
                    Semi Concluder

                  </label>
                  <label class="radio-inline">
                    <input type="radio" id="super-concluder" name="Is_Super_Concluder_Process" [value]="'true'"
                      formControlName="Is_Super_Concluder_Process" [(ngModel)]="clientData.Is_Super_Concluder_Process">
                    Super Concluder

                  </label>
                </div>
              </div> -->
              <div class="form-group" style="float: left;">
                <div class="row">
                  <div class="form-group d-flex">
                    <label class=" label-std control-label p-0 b-600 pl-0" style="margin-top: 10%;width: auto;"
                      for="">Auto-Deallocation</label>
                    <select class="form-control allocationDrop" formControlName="Auto_Allocation"
                      [(ngModel)]="clientData.Auto_Allocation" (change)="seletedDeallocationType($event)">
                      <option [Value]="data" id="{{i}}" [selected]="data == 'Weekly'"
                        *ngFor='let data of deallocationList;let i=index'>{{data}}</option>
                    </select>
                  </div>
                  <label class="error allocateErrorMsg"
                    *ngIf="addClient.get('Auto_Allocation').hasError('required') && validated">Required Field</label>
                  <ng-container *ngIf="isDaysDropdown">

                    <div class="d-flex" style="margin-left: 30px;">
                      <label class=" label-std control-label p-0 b-600 pl-0"
                        style="margin-top: 13%;width: auto;">Days</label>
                      <select id="{{i}}" class="form-control allocationDrop" formControlName="Auto_Allocation_Day"
                        [(ngModel)]="clientData.Auto_Allocation_Day">
                        <option value="">--Select--</option>
                        <option [Value]="data" *ngFor='let data of weekDays;let i=index '
                          [selected]="clientData.Auto_Allocation_Day==data">{{data}}</option>
                      </select>
                    </div>
                    <label class="error daysErrorMsg"
                      *ngIf="addClient.get('Auto_Allocation_Day').hasError('required') && validated">
                      Select Day</label>
                  </ng-container>
                </div>
              </div>
            </div>

          </div>
          <div class="col-md-12">
            <label class="error" *ngIf=" selectClient">Please Select Client.</label>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-right p-0 border-t">
        <button type="button" [disabled]="clearBtnDisable"
          class="btn blue square-btn blue-hover btn-txt mt-10 mb-10 mr-5 btn-default"
          (click)="clearForm()">Clear</button>
        <button *ngIf="!isLoaded" type="submit"
          class="btn blue square-btn blue-hover btn-txt mt-10 mb-10 mr-5 btn-default">Save</button>
        <button *ngIf="isLoaded" class="btn blue square-btn blue-hover btn-txt mt-10 mb-10 mr-5 btn-default"
          type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
            style="display: inline-block;margin: 0 5px;"></span>
          Saving...
        </button>
        <button type="button" [disabled]="nextBtnDisable"
          class="btn blue square-btn blue-hover btn-txt mt-10 mb-10 mr-5 btn-default" (click)="nextPage()">Next</button>
      </div>
    </form>
  </div>
</div>
<app-common-message-modal *ngIf="isConfirmed && activeConfirmedPopup" [successMessage]="confirmationMessage"
  (showNotification)="closeConfirmationPopup($event)"></app-common-message-modal>
